<template>
    <div>
        <policyHeader/>
        <div class="bannerBox">
            <a-carousel :dot-position="bottom">
                <div>
                    <img class="bannerImg" src="../img/lianxi.jpg"/>
                </div>
            </a-carousel>
        </div>
        <div style="width: 100%;background-color: #fff;">
            <div class="breadBox">
                <a-breadcrumb>
          <span>
            <img src="@/assets/img/position.png"/>
            当前位置：
          </span>
                    <a-breadcrumb-item>首页</a-breadcrumb-item>
                    <a-breadcrumb-item>联系我们</a-breadcrumb-item>
                </a-breadcrumb>
            </div>
        </div>
        <div class="tabBox">
            <div class="question" v-for="(item,index) in list" :key="index">
                <div class="title">{{item.name}}</div>
                <p v-html="item.remark"></p>
            </div>
            
            <div class="breadBox">
            <iframe
                    id="iframe_key"
                    ref="mainIframe"
                    src="../../static/index.html"
                    frameborder="0"
                    style="width:100%;height:400px"
                ></iframe>
            </div>
            
        </div>
        <LayoutFooter/>

    </div>
</template>
<script>
import policyHeader from "./policyHeader"
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2'
import {basicsContactInfo} from "@/api/innovationService";

export default {
    name: 'questionnaire',
    components: {policyHeader, LayoutFooter},
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            list: [],
            tData:{
                "data": [
                        {
                            "lng": "113.59883",
                            "lat": "37.86206"
                        }
                    ]
            }

        }
    },
    mounted(){
        this.getList()
    },
    methods: {
        selectPoint(){
            
			setTimeout(() => {
                
                const mapFrame = this.$refs['mainIframe'];
                const iframeWin = mapFrame.contentWindow;
                iframeWin.postMessage(
                    JSON.parse(JSON.stringify(this.tData.data)),
                    '*'
                );
                iframeWin.setZoomData(this.tData.data[0].lng,this.tData.data[0].lat,20)
            },500)
		},
            getList() {
                this.getAction({
                    url: basicsContactInfo.pageList,
                }).then(res => {
                    this.list = res.records
                    this.tData.data[0].lat = this.list[0].latitude
                    this.tData.data[0].lng = this.list[0].longitude
                    this.selectPoint()
                })
            },
        }
}
</script>
<style scoped lang="less">
.bannerBox {
    position: relative;
    width: 100%;
    //margin-bottom: 20px;

    .bannerImg {
        width: 100%;
        object-fit: cover;
    }

    .showMoreButton {
        position: absolute;
        top: 55%;
        left: 21.5%;
        width: 170px;
        height: 56px;
        text-align: center;
        line-height: 56px;
        background-color: #0048c4;
        color: #fff;
        cursor: pointer;
    }
}

.breadBox {
    width: 1200px;
    margin: 0 auto;
    padding: 10px 0;
}

.tabBox {
    width: 100%;
    margin: 0 auto;
    padding: 10px 0 20px 0;
    background: white;
    .question{
        width: 1200px;
        margin: 0 auto;
        .title{
            font-size: 22px;
            margin-bottom: 10px;
        }
        .phone{
            font-size: 18px;
        }
        .address{
            font-size: 18px;
            margin-bottom: 10px;
        }
        .imglogo{
            width: 500px;
            height: 300px;
        }
        .addresslogo{
            width: 650px;
            height: 300px;
        }
    }
}
</style>
